/* Electrodose: external copy of an inline script. Behavior is unchanged. */
(function(){
  if (window.__edoseCartBadgeInit) return;
  window.__edoseCartBadgeInit = true;

  function setBadge(count){
    count = parseInt(count, 10) || 0;
    document.querySelectorAll('.nav-cart .cart-count, .edose-nav__cart-badge').forEach(function(badge){
      badge.textContent = count;
      if (count > 0) {
        badge.setAttribute('data-cart-count-empty','false');
        badge.style.display = '';
      } else {
        badge.setAttribute('data-cart-count-empty','true');
        badge.style.display = 'none';
      }
    });
    // If a cart link has no badge element yet, create one
    if (count > 0) {
      document.querySelectorAll('.nav-cart').forEach(function(cart){
        if (!cart.querySelector('.cart-count')) {
          var s = document.createElement('span');
          s.className = 'cart-count';
          s.setAttribute('data-cart-count-empty','false');
          s.textContent = count;
          cart.appendChild(s);
        }
      });
    }
  }

  function refreshFromShopify(){
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(c){ setBadge(c && typeof c.item_count !== 'undefined' ? c.item_count : 0); })
      .catch(function(){});
  }

  // Expose globally so any ATC button anywhere can trigger an update
  window.edoseRefreshCartBadge = refreshFromShopify;
  window.edoseSetCartBadge = setBadge;

  function isCartMutation(url){
    if (typeof url !== 'string') return false;
    return /\/cart\/(add|change|update|clear)(\.js|\b)/.test(url);
  }
  function isCartAdd(url){
    if (typeof url !== 'string') return false;
    return /\/cart\/add(\.js|\b)/.test(url);
  }
  function onCartMutationSuccess(url){
    // Skip auto-open when already viewing /cart page
    var onCartPage = window.location.pathname.indexOf('/cart') === 0;
    setTimeout(function(){
      refreshFromShopify();
      if (isCartAdd(url) && !onCartPage) {
        document.dispatchEvent(new CustomEvent('edose:cart-added'));
      }
    }, 30);
  }

  // --- Intercept fetch ---
  if (window.fetch) {
    var _origFetch = window.fetch;
    window.fetch = function(){
      var args = arguments;
      var input = args[0];
      var url = '';
      try {
        if (typeof input === 'string') url = input;
        else if (input && typeof input.url === 'string') url = input.url;
      } catch(e){}
      var p = _origFetch.apply(this, args);
      if (isCartMutation(url)) {
        p.then(function(res){
          if (res && res.ok) onCartMutationSuccess(url);
        }).catch(function(){});
      }
      return p;
    };
  }

  // --- Intercept XMLHttpRequest ---
  try {
    var _origOpen = XMLHttpRequest.prototype.open;
    var _origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__edoseUrl = url;
      return _origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(){
      var xhr = this;
      var u = xhr.__edoseUrl || '';
      if (isCartMutation(u)) {
        xhr.addEventListener('load', function(){
          if (xhr.status >= 200 && xhr.status < 300) onCartMutationSuccess(u);
        });
      }
      return _origSend.apply(this, arguments);
    };
  } catch(e){}

  // --- Listen for standard Shopify cart events some themes/apps fire ---
  document.addEventListener('cart:updated',  refreshFromShopify);
  document.addEventListener('cart:refresh',  refreshFromShopify);
  document.addEventListener('cart:build',    refreshFromShopify);
  document.addEventListener('cart:added',    refreshFromShopify);
  document.addEventListener('product:added', refreshFromShopify);

  // --- Refresh once on page show (covers back/forward cache) ---
  window.addEventListener('pageshow', function(e){
    if (e.persisted) refreshFromShopify();
  });
})();
